// extracted by mini-css-extract-plugin
export default {"button":"chip_button__uCdcy","color":"chip_color__u+UGz","line":"chip_line__RlFIh","default":"chip_default__6O6-u"};